<template>
  <section class="new-products">
    <DefH2>{{ saveData.message.title }}</DefH2>
    <div class="new-products-tabs">
      <span
        v-for="tab in saveData.tabs"
        :key="tab.id"
        class="new-products-tabs__item"
        :class="{ 'new-products-tabs__item_active': tab.active }"
        @click="handlerChangeTab(tab)"
      >
        {{ tab.name }}
      </span>
    </div>
    <!--    <DefSelectWrapper>-->
    <!--      <template #header>-->
    <!--        {{ activeTab.name }}-->
    <!--      </template>-->
    <!--      <div v-for="tab in saveData.tabs" :key="tab.id" @click="handlerChangeTab(tab)">-->
    <!--        {{ tab.name }}-->
    <!--      </div>-->
    <!--    </DefSelectWrapper>-->
    <DefSlider ref="slider" :nav="screenWidth >= 992" :pagination="true" :settings="settings">
      <div
        v-for="item in getActiveProducts"
        :key="(item.offer && item.offer.id) || item.id"
        class="swiper-slide"
      >
        <SliderCard :result="item" />
      </div>
      <div class="swiper-slide">
        <div class="all-card">
          <a :href="activeTab.detailPage" class="all-card-link">
            {{ saveData?.message?.showAll }}
            <svg class="all-card-link__icon">
              <use xlink:href="#svg-arrow-right"></use>
            </svg>
          </a>
        </div>
      </div>
    </DefSlider>

    <div class="new-products__look">
      <DefButtonSecondary :href="saveData?.tabs?.[0]?.detailPage">
        {{ saveData?.tabs?.[0]?.name }}
      </DefButtonSecondary>
    </div>
  </section>
</template>

<script>
import DefH2 from '@components/Def/DefH/DefH2.vue';
import DefSlider from '@components/Def/DefSlider/DefSlider.vue';
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import useScreenWidth from '@use/useScreenWidth';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';

export default {
  name: 'NewProducts',
  components: { DefButtonSecondary, SliderCard, DefSlider, DefH2 },
  props: ['result'],
  data() {
    return {
      saveData: this.result,
      settings: {
        slidesPerView: 1.4,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 2.4,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
      },
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    activeTab() {
      return this.saveData?.tabs?.find((el) => el.active);
    },
    getActiveProducts() {
      if (this.activeTab?.id !== 0) {
        return this.saveData.items.filter((el) => el.sectionID == this.activeTab?.id);
      }
      return this.saveData.items;
    },
  },
  methods: {
    async handlerChangeTab(tab) {
      this.saveData.tabs = this.saveData.tabs.map((el) => ({
        ...el,
        active: tab.id == el.id,
      }));
      this.$nextTick();
      this.$refs.slider.slider.slideTo(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.new-products {
  margin-bottom: 64px;
  @include point-lg {
    margin-bottom: 80px;
  }
  &__look {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    :deep(.def-button-secondary) {
      width: 100%;
      @include point-md {
        width: auto;
      }
    }
  }
  :deep(.def-h2) {
    text-align: center;
  }
  :deep(.def-slider__prev) {
    left: 0;
    transform: translate(-50%, -50%);
  }
  :deep(.def-slider__next) {
    right: 0;
    transform: translate(50%, -50%);
  }
  :deep(.swiper-wrapper) {
    align-items: stretch;
  }
  .swiper-slide {
    height: unset;
  }
}
.new-products-tabs {
  text-align: center;
  color: #3f3f44;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  text-transform: uppercase;
  overflow-x: auto;
  text-wrap: nowrap;
  padding-bottom: 12px;
  margin-bottom: 12px;
  @include point-md {
    justify-content: center;
  }
  &__item {
    cursor: pointer;
    transition: 0.2s linear color;
    text-decoration: underline;
    text-underline-position: under;
    text-decoration-color: transparent;
    &:not(:last-child) {
      margin-right: 32px;
    }
    &_active {
      color: var(--color-main);
      text-decoration-color: currentColor;
    }
  }
}
.all-card {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  height: 100%;
}
.all-card-link {
  display: inline-flex;
  align-items: center;
  color: var(--color-golden-browm);
  gap: 4px;
  &__icon {
    width: 20px;
    height: 20px;
    fill: currentColor;
  }
}
</style>
